import { render, staticRenderFns } from "./OsdiFileInput.vue?vue&type=template&id=0fa123a2&scoped=true&"
import script from "./OsdiFileInput.vue?vue&type=script&lang=js&"
export * from "./OsdiFileInput.vue?vue&type=script&lang=js&"
import style0 from "./OsdiFileInput.vue?vue&type=style&index=0&id=0fa123a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa123a2",
  null
  
)

export default component.exports